<script setup lang="ts">
import UiChip from './UiChip.vue';
</script>

<template>
    <UiChip 
        text="PRO" 
        size="xs" 
        rounded="small" 
        variant="dark" 
        class="font-semibold"
        tooltip="This content only shows on Pro plan profiles"
    />
</template>